import { render, staticRenderFns } from "./order-evaluation.vue?vue&type=template&id=2ab1fe23&scoped=true"
import script from "./order-evaluation.vue?vue&type=script&lang=js"
export * from "./order-evaluation.vue?vue&type=script&lang=js"
import style0 from "./order-evaluation.vue?vue&type=style&index=0&id=2ab1fe23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1fe23",
  null
  
)

export default component.exports